import request from '@/axios/personalCenter'

// R01-获取01平面规划方案详情
export function getOneDetails(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getOneDetails',
    method: 'post',
    data
  })
}

// R02-获取02功能设计方案详情
export function getTwoDetails(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getTwoDetails',
    method: 'post',
    data
  })
}

// R03-获取效果搭配方案详情
export function getThreeDetails(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getThreeDetails',
    method: 'post',
    data
  })
}

// R04-获取产品设计方案详情
export function getFourDetails(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getFourDetails',
    method: 'post',
    data
  })
}

// R11-获取设计订单空间列表
export function getDesignSpaceList(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getDesignSpaceList',
    method: 'post',
    data
  })
}

// R08-获取产品配置方案分类列表
export function getProductCategoryList(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getProductCategoryList',
    method: 'post',
    data
  })
}

// A-22-客诉详情（小程序）
export function getComplaintInfoUcenter(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/after/getComplaintInfo',
    method: 'post',
    data
  })
}

// F-03-问题处理评价
export function addEvaluate(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/complaint/addEvaluate',
    method: 'post',
    data
  })
}

// F-07-问题处理详情
export function getComplaintInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintInfo',
    method: 'post',
    data
  })
}
